<form [formGroup]="customAccessoryForm" (ngSubmit)="create()">
  <div class="modal-content w-100 h-100 d-flex flex-column justify-content-between">
    <apm-section-title title="{{ '445314' | apmTranslate }}"></apm-section-title>
    <div class="custom-accessory-content ps-1">
      <div class="row mb-3">
        <div class="col-12">
          <div class="input-title">
            <label for="name">{{ '445315' | apmTranslate }}* </label>
            <input
              class="w-100 apm-input error"
              id="name"
              type="text"
              [ngClass]="{ error: customAccessoryForm.get('name')?.errors && customAccessoryForm.get('name')?.touched }"
              formControlName="name"
            />
          </div>
        </div>
      </div>
      <fieldset [disabled]="!hasMenageCustomAndRfqPermission">
        <div class="row mb-3">
          <div class="col-6">
            <div class="input-title">
              <label for="sapOfferNumber">{{ '445321' | apmTranslate }}</label>
              <input
                class="w-100 apm-input error"
                id="sapOfferNumber"
                type="text"
                [ngClass]="{
                  error:
                    customAccessoryForm.get('sapOfferNumber')?.errors &&
                    customAccessoryForm.get('sapOfferNumber')?.touched,
                }"
                formControlName="sapOfferNumber"
              />
            </div>
          </div>
          <div class="col-6">
            <div class="input-title">
              <label for="positionCode"
                >{{ '445319' | apmTranslate }}
                @if (customAccessoryForm.get('positionCode')?.errors?.required ?? false) {
                  <span>*</span>
                }
              </label>
              <input
                class="w-100 apm-input error"
                id="positionCode"
                type="number"
                [ngClass]="{
                  error:
                    customAccessoryForm.get('positionCode')?.errors && customAccessoryForm.get('positionCode')?.touched,
                }"
                formControlName="positionCode"
              />
            </div>
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-6">
            <div class="input-title">
              <label for="commodityCode">{{ '445317' | apmTranslate }}* </label>
              <input
                class="w-100 apm-input error"
                id="commodityCode"
                type="text"
                [ngClass]="{
                  error:
                    customAccessoryForm.get('commodityCode')?.errors &&
                    customAccessoryForm.get('commodityCode')?.touched,
                }"
                formControlName="commodityCode"
              />
            </div>
          </div>
          <div class="col-6">
            <div class="input-title">
              <label for="materialCode">{{ '445318' | apmTranslate }}* </label>
              <input
                class="w-100 apm-input error"
                id="materialCode"
                type="text"
                [ngClass]="{
                  error:
                    customAccessoryForm.get('materialCode')?.errors && customAccessoryForm.get('materialCode')?.touched,
                }"
                formControlName="materialCode"
              />
            </div>
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-6">
            <div class="input-title">
              <label for="atpCode">{{ '445316' | apmTranslate }} </label>
              <input
                class="w-100 apm-input error"
                id="atpCode"
                type="text"
                [ngClass]="{
                  error: customAccessoryForm.get('atpCode')?.errors && customAccessoryForm.get('atpCode')?.touched,
                }"
                formControlName="atpCode"
              />
            </div>
          </div>
          <div class="col-6">
            <div class="input-title">
              <label for="validityDate">{{ '445322' | apmTranslate }}* </label>
              <apm-datepicker class="w-100" id="validityDate" formControlName="validityDate"></apm-datepicker>
            </div>
          </div>
        </div>
        @if (hasMenageCustomAndRfqPermission) {
          <div class="row mb-3">
            <div class="col-12">
              <div class="input-title mb-3">
                <label for="priceList">{{ '445320' | apmTranslate }}* </label>
                <apm-currency-input
                  id="priceList"
                  [currencyMask]="{ prefix: currencySymbol + ' ' }"
                  additionalClass="w-100 apm-input {{
                    customAccessoryForm.get('local')?.errors && customAccessoryForm.get('local')?.touched ? 'error' : ''
                  }}"
                  formControlName="priceList"
                ></apm-currency-input>
              </div>
              <mat-checkbox formControlName="sendToSap">
                <span class="text-md bold">{{ 448783 | apmTranslate }}</span>
              </mat-checkbox>
            </div>
          </div>
        }
      </fieldset>
    </div>
    <div>
      <div class="row mt-4">
        <apm-button variant="secondary" [class.col-6]="!dialogData.readonly" (click)="closeDialog()">{{
          '444714' | apmTranslate
        }}</apm-button>
        @if (!dialogData.readonly) {
          <apm-button class="col-6 p-0" type="submit" [disabled]="customAccessoryForm.invalid">{{
            '444735' | apmTranslate
          }}</apm-button>
        }
      </div>
    </div>
  </div>
</form>
